import { render } from "./TodoList.vue?vue&type=template&id=4e72b494"
import script from "./TodoList.vue?vue&type=script&lang=js"
export * from "./TodoList.vue?vue&type=script&lang=js"

import exportComponent from "C:\\raro\\raro-web\\argon-cel\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__